import { createContext, useEffect, useState } from 'react';
import { Role } from '../types/Role';
import { useLocation, useNavigate } from 'react-router-dom';
import { routeUrls, routes } from '../routes';

export type User = {
    userRole: Role;
    accessToken: string;
};

export const UserContext = createContext({
    userRole: Role.USER,
    accessToken: '',
    setUserRole: (user: Role) => {},
});

export const UserProvider = ({ children, role, accessToken }: { role: Role; accessToken: string; children: React.ReactNode }) => {
    const [userRole, setUserRole] = useState(role || Role.USER);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const activeRoute = routes.find((route) => location.pathname.includes(route.path));

        if (activeRoute && !hasAccess(userRole, activeRoute.accessLevel)) {
            navigate(routeUrls.DASHBOARD);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userRole]);

    return <UserContext.Provider value={{ userRole, accessToken, setUserRole }}>{children}</UserContext.Provider>;
};

export const hasAccess = (currentUser: Role, accessLevel: Role) => {
    return currentUser === Role.ADMIN || accessLevel === Role.USER;
};
